import { Apollo } from 'apollo-angular'
import { ApolloQueryResult } from '@apollo/client/core'
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core'

import { cloneDeep } from 'lodash'
import { camel, safeGet, StringObjectLiteral } from '../../util/util'
import { surveyTestsDetails_survey_test_by_pk } from '../survey-tests-details/types/surveyTestsDetails'
import editMutation from './survey-tests-edit.gql'
import relatedEntityQuery from './survey_test_get_related_entities.gql'
import { edit_survey_test_by_pk } from './types/edit_survey_test_by_pk'
import { survey_test_get_related_entities } from './types/survey_test_get_related_entities'

@Component({
  selector: 'app-survey-tests-edit',
  templateUrl: './survey-tests-edit.component.html',
  styleUrls: ['./survey-tests-edit.component.scss'],
})
export class SurveyTestsEditComponent implements OnInit {
  @Input() survey_test: surveyTestsDetails_survey_test_by_pk

  private _backup_survey_test: surveyTestsDetails_survey_test_by_pk

  @Output() saveEvent = new EventEmitter()

  safeGet = safeGet

  objectKeys = Object.keys

  relatedEntityOptionsQueryResult: ApolloQueryResult<
    survey_test_get_related_entities
  >

  constructor(private apollo: Apollo) {}

  fetchRelatedEntityOptions() {
    this.apollo
      .query<survey_test_get_related_entities>({ query: relatedEntityQuery })
      .subscribe({
        next: (result) => {
          if (result.errors) {
            throw result.errors[0]
          }
          this.relatedEntityOptionsQueryResult = result
        },
      })
  }

  get relatedEntityOptions(): survey_test_get_related_entities {
    return this.relatedEntityOptionsQueryResult.data
  }

  ngOnInit() {
    this._backup_survey_test = cloneDeep(this.survey_test)
    this.fetchRelatedEntityOptions()
  }

  save() {
    this.apollo
      .mutate<edit_survey_test_by_pk>({
        mutation: editMutation,
        variables: {
          id: this.survey_test.id,
          _set: this.stripInput(this.survey_test),
        },
      })
      .subscribe({
        next: (result) => {
          if (result.errors) {
            throw result.errors[0]
          }
          this.saveEvent.emit('edit')
        },
      })
  }

  back() {
    this.survey_test = cloneDeep(this._backup_survey_test)
    this.saveEvent.emit('back')
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  stripInput = (obj: StringObjectLiteral<any>) =>
    Object.keys(obj).reduce((newObj, key) => {
      if (
        key !== 'id' &&
        key !== 'dateCreated' &&
        key !== 'dateUpdated' &&
        key !== '__typename'
      ) {
        if (
          typeof obj[key] === 'string' ||
          typeof obj[key] === 'number' ||
          (obj[key] === null && key.slice(-2) === 'Id')
        ) {
          newObj[camel(key)] = obj[key]
        }
      }
      return newObj
    }, {})
}
